/* eslint-disable */
/// This file is auto generated - do not edit manually
export * as DeliveryGroup from './trans-website-checkout-delivery-deliverygroup';
export * as KlarnaExpress from './trans-website-checkout-delivery-klarnaexpress';
export * as InvoiceAddress from './trans-website-checkout-delivery-invoiceaddress';
export * as ParcelShop from './trans-website-checkout-delivery-parcelshop';
export * as HomeDelivery from './trans-website-checkout-delivery-homedelivery';
export * as BusinessDelivery from './trans-website-checkout-delivery-businessdelivery';
export * as InvalidAddress from './trans-website-checkout-delivery-invalidaddress';

export const Headline = 'Website.Checkout.Delivery.Headline';
export const RecommendedMethodsHeadline = 'Website.Checkout.Delivery.RecommendedMethodsHeadline';
export const SelectedMethodHeadline = 'Website.Checkout.Delivery.SelectedMethodHeadline';
export const MoreMethodsHeadline = 'Website.Checkout.Delivery.MoreMethodsHeadline';
export const ShowMoreMethodsText = 'Website.Checkout.Delivery.ShowMoreMethodsText';
export const ShowLessMethodsText = 'Website.Checkout.Delivery.ShowLessMethodsText';
export const EditAddressButtonText = 'Website.Checkout.Delivery.EditAddressButtonText';
export const SaveAddressButtonText = 'Website.Checkout.Delivery.SaveAddressButtonText';
export const CancelAddressButtonText = 'Website.Checkout.Delivery.CancelAddressButtonText';
export const ShowLessProductsText = 'Website.Checkout.Delivery.ShowLessProductsText';
